var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_layer_group_layer_interface = function () {
    OCS.Viewer.Interfaces.LayerGroupLayer = {
        layer_class_obj: null,
        active_layer: null, // A pointer of sorts to the earliest created layer
        show_current_frame_timeout: null,
        init_layer_events: function () {
            this.addEvent('destroy_layer_group', this.destroy_layer.bind(this));
            this.addEvent('add_layer', this.on_add_layer.bind(this));
            this.addEvent('remove_layer', this.on_remove_layer.bind(this));
            this.addEvent('activate_layer', this.on_activate_layer.bind(this));
            this.addEvent('deactivate_layer', this.on_deactivate_layer.bind(this));
            this.addEvent('new_layer_source', this.on_new_layer_source.bind(this));
        },
        /*
         * Event Fires
         */
        add_layer: function (layer) {
            if (layer) {
                this.fireEvent('add_layer', layer, 1);
            }
        },

        get_layer_class: function () {
            return this.options.layer_class;
        },
        set_layer_class: function (layer_class) {
            this.options.layer_class = layer_class;
        },
        get_layer_class_obj: function () {
            if (!this.layer_class_obj) {
                var layer_class = this.get_layer_class();
                var util = OCS.Viewer.Functions.get_utilities();
                if (layer_class && (!util.is_undefined(OCS.Viewer.Classes[layer_class]) || !util.is_undefined(OCS.Viewer.Functions["define_" + layer_class]))) {
                    if (!util.is_undefined(OCS.Viewer.Functions["define_" + layer_class])) {
                        this.layer_class_obj = OCS.Viewer.Functions["define_" + layer_class](null, null, this.options);
                    } else {
                        this.layer_class_obj = OCS.Viewer.Classes[layer_class];
                    }
                } else {
                    console.warn('Layer Group: ' + layer_class + " is undefined!");
                }
            }
            return this.layer_class_obj;
        },

        /*
         *  Layer related methods 
         */
        instantiate_layer: function (layer_op) {
            var layer_class = this.get_layer_class_obj();
            if (layer_class) {
                layer_op = this.create_layer_options(layer_op);
                return new layer_class(layer_op);
            }
        },
        create_layer: function (layer_op) {
            // Create a new instance of the class defined by the options
            var source;

            var layer_instance = this.instantiate_layer(layer_op);
            if (layer_instance) {
                layer_instance.addEvent('ready', this.on_layer_ready.bind(this));
                if (layer_op.source) {
                    source = layer_op.source;
                    delete layer_op.source;
                    layer_instance.set_source_obj(source);
                }
                layer_instance.set_style_manager(this.get_style_manager());
                this.fireEvent('layer_created', layer_instance);
                return layer_instance;
            }
        },
        get_active_layer: function () {
            if (this.active_layer) {
                return this.active_layer;
            } else {
                this.fireEvent('show_current_layer');
            }
        },
        get_active_layer_source_obj: function () {
            var layer = this.get_active_layer();
            if (layer) {
                return layer.get_source_obj();
            }
        },
        set_active_layer: function (layer) {
            if (layer) {
                if (this.active_layer && this.active_layer.id === layer.id) {
                    return true;
                }

                if (this.active_layer) {
                    this.clear_active_layer();
                }
                if (this.is_visible()) {
                    layer.make_visible();
                }
                layer.set_opacity(1.0);
                this.active_layer = layer;
                this.fireEvent('layer_active', this, 1);
                return true;
            } else {
                if (!this.is_static()) {
                    this.clear_active_layer();
                }
            }
            return false;
        },
        clear_active_layer: function () {
            if (this.active_layer) {
                this.active_layer.make_invisible();
                this.fireEvent('layer_deactive', this.active_layer, 1);
                this.active_layer = null;
                
            }
        },
        create_layer_options: function (layer_ops) {
            var util = OCS.Viewer.Functions.get_utilities();
            return util.combine_objects({'layer_style_ops': this.options.layer_style_ops}, layer_ops, {merge: true, deep: true});
        },
        // Event Listeners
        on_activate_layer: function (layer) {
            this.set_active_layer(layer);
        },
        on_deactivate_layer: function () {
            this.clear_active_layer();
        },
        on_new_layer_source: function (source, timestamp) {
            var layer_op = this.create_layer_options(source.get_metadata());
            var layer = this.create_layer(layer_op);
            layer.set_source_obj(source);
            if (!layer.is_ready) {
                // Once the layer reports ready, add it
                layer.addEvent('ready', this.add_layer.bind(this));
            } else {
                this.add_layer(layer);
            }

        },

        on_add_layer: function (layer_obj) {
            // Default the layer to be invisible
            layer_obj.make_invisible();

            var group = this.get_ol_object();
            var layers = group.getLayers();
            var ol_layer = layer_obj.get_layer();
            if (ol_layer) {
                layers.push(ol_layer);
                if (!this.active_layer && this.is_static()) {
                    this.set_active_layer(layer_obj);
                }
            }
            this.fireEvent("layer_added", [layer_obj, this], 1);
        },
        on_remove_layer: function (layer) {
            if (layer) {
                layer.make_invisible();
                // Delete the open layers layer
                var group = this.get_ol_object();
                var layers = group.getLayers();
                layers.remove(layer.get_layer());
                layer.delete();
                this.fireEvent("layer_removed", this, 1);
            }
        },
        on_layer_ready: function (layer) {
            this.ready();
            if (this.show_current_frame_method) {
                this.show_current_frame_timeout = setTimeout(this.show_current_frame_method.bind(this), 1000);
            }
        },
        destroy_layer: function () {
            if (this.show_current_frame_timeout) {
                clearTimeout(this.show_current_frame_timeout);
                this.show_current_frame_timeout = null;
            }
            this.clear_active_layer();
        }
    };
};
OCS.Viewer.Functions.define_layer_group_layer_interface();